import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "parts/Cards/InfoCards/DefaultInfoCard";
import CenteredBlogCard from "parts/Cards/BlogCards/CenteredBlogCard";
// Image
import bgImage from "assets/images/contact.jpg";
function Information() {
  return (
    <MKBox
      component="section"
      py={12}
      sx={{
        pt: "100px",  // Adds space at the top to avoid overlap with fixed navbar
      }}
    >
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={6}>
            <Grid container justifyContent="flex-start">
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="public"
                    title="Content Generation"
                    description="Effortlessly create high-quality, engaging content with our generative AI. Whether you need blog posts, product descriptions, or social media content, our advanced technology delivers professional results, saving you valuable time and resources."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="public"
                    title="TTS & STT"
                    description="Leverage state-of-the-art Text-to-Speech (TTS) and Speech-to-Text (STT) capabilities. Our AI generates natural, human-like speech for audio applications and accurately transcribes audio into text, improving accessibility and enhancing the user experience across platforms."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Custom Reports"
                    description="Transform raw data into actionable insights with our AI-powered Custom Reports. Automatically generate tailored, data-driven reports that provide a deep analysis of business performance, trends, and metrics—empowering decision-makers with real-time information."
                  />
                </MKBox>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} lg={4} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <CenteredBlogCard
              image={bgImage}
              title="Get insights"
              description="In today's rapidly evolving digital landscape, staying informed is key to making smart decisions. At HP Tech Solutions, we provide valuable insights into the latest trends, challenges, and opportunities in software development and cybersecurity."
              action={{
                type: "internal",
                route: "/pages/landing-pages/contact-us",
                color: "info",
                label: "Contact",
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
